import { skipToken, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

export const FontMetadataSchema = z.object({
  category: z.string(),
  family: z.string(),
  files: z.record(z.string(), z.string()),
  variants: z.array(z.string()),
});

export type FontMetadata = z.infer<typeof FontMetadataSchema>;

const PRIVATE_FONT_METADATA_KEY = 'PRIVATE_FONT_METADATA';

export type PrivateFontMetadataParams = {
  metadataUrl: string | undefined;
};

export const getPrivateFontMetadataKey = (params: PrivateFontMetadataParams) => {
  return [PRIVATE_FONT_METADATA_KEY, params];
};

export type UsePrivateFontMetadataOptions = {
  enabled?: boolean;
};

export const fetchFontMetadata = async (metadataUrl: string): Promise<FontMetadata> => {
  const res = await fetch(metadataUrl);

  return FontMetadataSchema.parse(await res.json());
};

export const usePrivateFontMetadata = (params: PrivateFontMetadataParams, options?: UsePrivateFontMetadataOptions) => {
  const { metadataUrl } = params;

  return useQuery({
    enabled: !!metadataUrl && (options?.enabled ?? true),
    queryFn: metadataUrl ? () => fetchFontMetadata(metadataUrl) : skipToken,
    queryKey: getPrivateFontMetadataKey(params),
    staleTime: Infinity,
  });
};
